import { OperatorFunction } from 'rxjs/interfaces';
import { pipeFromArray } from 'rxjs/internal/util/pipe';
import { Observable } from 'rxjs/Observable';
import {
  ActionsConditionalParams,
  EventsConditionalParams,
  MutationsConditionalParams,
  Wire,
  WireFactory,
  WireFactoryCondition
} from '../wiring.interfaces';

const defaultCondition: WireFactoryCondition = (payload: any) => !!payload;

function applyOptionalPipe(observable: Observable<any>, pipes?: OperatorFunction<any, any>[]): Observable<any> {
  return pipes ? observable.pipe(pipeFromArray(pipes)) : observable;
}

export const WIRE_FACTORY: WireFactory = {
  emitEvent(eventName: string, payloadParam?: any, ...pipes: OperatorFunction<any, any>[]): Wire {
    return (observable, { emit }) =>
      applyOptionalPipe(observable, pipes)
        .subscribe((payload: any) => emit(eventName, payloadParam === undefined ? payload : payloadParam));
  },
  dispatchAction(actionName: string, payloadParam?: any, ...pipes: OperatorFunction<any, any>[]): Wire {
    return (observable, { store }) => {
      applyOptionalPipe(observable, pipes)
        .subscribe(payload => store.dispatch(actionName, payloadParam === undefined ? payload : payloadParam));
    };
  },
  commitMutation(mutationName: string, payloadParam?: any, ...pipes: OperatorFunction<any, any>[]): Wire {
    return (observable, { store }) => {
      applyOptionalPipe(observable, pipes)
        .subscribe(payload => store.commit(mutationName, payloadParam === undefined ? payload : payloadParam));
    };
  },
  emitEventConditionally({ ifEvent, elseEvent, ifPayload, elsePayload }: EventsConditionalParams,
    condition: WireFactoryCondition = defaultCondition, ...pipes: OperatorFunction<any, any>[]): Wire {

    return (observable, { emit, store }) =>
      applyOptionalPipe(observable, pipes).subscribe((payload: any) => {
        if (condition(payload, store)) {
          emit(ifEvent, ifPayload === undefined ? payload : ifPayload);
        } else if (elseEvent) {
          emit(elseEvent, elsePayload === undefined ? payload : elsePayload);
        }
      });
  },
  dispatchActionConditionally({ ifAction, elseAction, ifPayload, elsePayload }: ActionsConditionalParams,
    condition: WireFactoryCondition = defaultCondition, ...pipes: OperatorFunction<any, any>[]): Wire {

    return (observable, { store }) => {
      applyOptionalPipe(observable, pipes).subscribe((payload: any) => {
        if (condition(payload, store)) {
          store.dispatch(ifAction, ifPayload === undefined ? payload : ifPayload);
        } else if (elseAction) {
          store.dispatch(elseAction, elsePayload === undefined ? payload : elsePayload);
        }
      });
    };
  },
  commitMutationConditionally({ ifMutation, elseMutation, ifPayload, elsePayload }: MutationsConditionalParams,
    condition: WireFactoryCondition = defaultCondition, ...pipes: OperatorFunction<any, any>[]): Wire {

    return (observable, { store }) => {
      applyOptionalPipe(observable, pipes).subscribe((payload: any) => {
        if (condition(payload, store)) {
          store.commit(ifMutation, ifPayload === undefined ? payload : ifPayload);
        } else if (elseMutation) {
          store.commit(elseMutation, elsePayload === undefined ? payload : elsePayload);
        }
      });
    };
  }
};
